<!------------------------------------------------------------------------------
  Copyright (c) 2020. keni

  This file BundleSeasonTickets.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  BundleSeasonTickets.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<template>
    <div>
        <tileCardTicket v-for="(ticket,index) in tickets_compiled"
                        :data-index="index"
                        :info_full_width="false"
                        class="text-left"
                        :key="ticket.id"
                        :ticket="ticket"
                        :index="makeIndex(index)"
                        @toggle="toggleTicket"
                        @ticket_clicked="ticketClicked(ticket.id)"
        ></tileCardTicket>
    </div>
</template>

<script>
    // import {$basketController} from '../../config/config.js';
    window.Vue.component('tile-card', require('../front/modules/tileCardTicket'));
    export default {
        name: "BundleSeasonTickets",
        props: {
            addons: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            tickets: Array,
            add_ticket_url: String,
            tickets_limit: {
                type: Number,
                default: 40
            }
        },
        data() {
            return {
                display_modal: false,
                tickets_compiled: []
            }
        },
        mounted() {
            this.tickets_compiled = this.tickets;
//             $basketController
//                 .$on('read_basket', function (ticket_id) {
//                     // console.log('elm',elm)
//                     // console.log(self.tickets);
// // console.log(self.tickets.length)
//                     // is the id in the list?
//                     for (let i = 0; i < self.tickets.length; i++) {
//                         let ticket = self.tickets[i];
//
//                         // console.log(ticket, ticket.id, ticket_id, ticket.id === ticket_id);
//                         if (ticket.ticket_type !== 'addon' && ticket.id === ticket_id) {
//                             self.display_modal = true;
//                             break;
//                         }
//                     }
//                 });
        },
        methods: {
            // modalClosed() {
            //     this.display_modal = false;
            // },
            ticketClicked(id) {
                this.$emit('ticket_clicked', {
                    is_bundle: true,
                    id: id
                })
            },
            toggleTicket(index) {
                let self = this;
                self.tickets_compiled[index].show = !self.tickets_compiled[index].show;
            },
            makeIndex(index) {
                return parseInt(index)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/layouts/BundleSeasonTickets.vue